/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PostGroupManagerListPostGroupResponse } from "./PostGroupManagerListPostGroupResponse";

export type PostGroupManagerListPostGroupResponseApiRespoonse = {
  data?: PostGroupManagerListPostGroupResponse;
  status?: PostGroupManagerListPostGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace PostGroupManagerListPostGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
